import { ref } from 'vue';
import Request from '@/services/request';
import { EARLY_SETTLEMENT_CALCULATE } from '@/utils/enum/endpoints';

const Req = new Request();

export default function useEarlySettlementCalculate() {
  const data = ref(null);
  const error = ref(null);
  const isLoading = ref(false);

  const calculate = async (payload) => {
    isLoading.value = true;
    try {
      const response = await Req.post(EARLY_SETTLEMENT_CALCULATE, payload, {
        baseURL: '/sellerofficeapi/rest',
        headers: { Accept: 'application/json' },
      });

      if (response.status === 200) {
        data.value = response.data;
        error.value = null;
      } else {
        throw new Error('Network response was not OK');
      }
    } catch (err) {
      error.value = err || null;
    } finally {
      isLoading.value = false;
    }
  };

  const reset = () => {
    data.value = null;
    error.value = null;
  };

  return {
    data,
    error,
    isLoading,
    calculate,
    reset,
  };
}


